import AutoCompleteBrands from '@components/AutoComplete/AutoCompleteBrands';
import InputAutocompleteCity from '@components/InputAutocompleteCity';
import InputFieldControlled from '@components/InputFieldControlled';
import { useFormContext } from 'react-hook-form';

type Props = {
    pro: any;
};

const JobOfferTemplateProfileForm = ({ pro }: Props) => {
    const { control, setValue, register, getValues } = useFormContext();
    const values = getValues();

    return (
        <>
            <InputFieldControlled
                name="title"
                control={control}
                label="Titre du modèle"
                placeholder="Saisissez le titre du poste, la mention H/F sera ajoutée automatiquement"
                required
            />

            <AutoCompleteBrands name="brandId" control={control} label="Marque / Enseigne" proId={pro?._id} required />

            <InputFieldControlled
                name="address"
                control={control}
                label="Adresse"
                disabled={!pro?.isGroup}
                placeholder="Ex: 12 rue de la paix"
                defaultValue={values?.address}
            />

            <InputAutocompleteCity
                name="city"
                label="Ville"
                disabled={!pro?.isGroup}
                placeholder="Ex: Paris"
                required
                onSelectProp={(city: string, postalCode: string) => {
                    setValue('city', city);
                    setValue('postalCode', postalCode);
                }}
            />

            <input hidden name="postalCode" {...register('postalCode')} />
        </>
    );
};

export default JobOfferTemplateProfileForm;
